/**
 * @typedef {Object} dashbaordState
 */
export default {};
